<template>
    <div>
        <b-button pill variant="outline-info" class="px-4 pl-5 position_btn_notification" @click="onToggle">
            <span class="notification text-secundary" v-if="events.length">
                {{
                    events.length >= 100 ? 99 + "+" : events.length
                }}
            </span>
            <i class="flaticon2-bell-2 text-secundary"></i>
            <span class="pulse-ring" v-if="events.length"></span>
        </b-button>
        <div v-if="isShow" class="position_content_notification">
            <b-card :class="[dark ? 'dark-mode-page' : '']">
                <transition name="slide-fade" :class="[dark ? 'dark-mode-page' : '']">
                    <div
                        :class="[dark ? 'd-flex justify-content-between dark-mode-page' : 'd-flex justify-content-between']">
                        <div class="title">
                            <div class="d-flex flex-row">
                                <h3 class="card-title mr-5">Brigadas detenidas</h3>
                                <span>
                                    <b-badge :variant="statusBadgeColor">{{ statusSSE }}</b-badge>
                                </span>
                            </div>

                        </div>
                        <div class="options">
                            <button class="btn btn-sm btn-outline-danger pl-4" @click="onToggle">
                                <i class="flaticon2-delete"></i>
                            </button>
                        </div>
                    </div>
                </transition>

                <transition name="slide-fade">
                    <b-row
                        :class="[dark ? 'd-flex justify-content-center dark-mode-page' : 'd-flex justify-content-center']">
                        <b-col>
                            <CustomDataGrid :items="events" :headers="[
                                { dataField: 'usuario', caption: 'Usuario' },
                                { dataField: 'sector', caption: 'Sector' },
                                { dataField: 'cliente', caption: 'Delegacion' },
                                { dataField: 'gps', caption: 'Gps' },
                                { dataField: 'ultima_actualizacion', caption: 'Ultima actualizacion' },
                                { dataField: 'tiempo_inactivo', caption: 'Tiempo inactivo' },
                            ]" />
                        </b-col>
                    </b-row>
                </transition>
            </b-card>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import ENV from '@/environment.js';
import CustomDataGrid from '@/components/admin/reports/children/utils/CustomDataGrid.vue';

export default {
    components: {
        CustomDataGrid,
    },
    data() {
        return {
            // SSE,
            abortController: null,
            events: [],
            statusSSE: false,
            isWhile: true,

            isShow: false,
        };
    },
    mounted() {
        this.connectSSEV2();
    },
    beforeDestroy() {
        this.disconnectSSE();
    },
    computed: {
        ...mapGetters({
            dark: "mode/getTheme",
            getSectores: "auth/getSectores",
        }),
        statusBadgeColor() {
            const statusBadge = {
                Error: "danger",
                Conectado: "success",
                Desconectado: "warning",
                ["Cargando..."]: "info",
            }
            return statusBadge[this.statusSSE];
        }
    },
    methods: {
        onToggle() {
            this.isShow = !this.isShow;
        },
        async connectSSEV2(sectoresStr) {
            this.statusSSE = "Cargando...";
            const api = process.env.NODE_ENV == "development" ? ENV.API_DEV : ENV.API;
            const token = sessionStorage.getItem("token");
            if (sectoresStr?.length === 0) return;
            try {
                this.abortController = new AbortController();
                const response = await fetch(
                    `${api}alerta/inactividad-brigadas?sectores=${JSON.stringify(sectoresStr)}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "text/event-stream",
                        },
                        signal: this.abortController.signal
                    }
                );
                this.statusSSE = "Conectado";
                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                while (this.isWhile) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    const chunk = decoder.decode(value, { stream: true });
                    // separar eventos SSE
                    const lines = chunk.split("\n");
                    lines.forEach(line => {
                        if (line.startsWith("data:")) {
                            const json = line.replace("data:", "").trim();
                            if (json) {
                                const data = JSON.parse(json);
                                this.events = data;
                            }
                        }
                    });
                }
            }
            catch (error) {
                if (error.name === "AbortError") {
                    await this.disconnectSSE();
                }
                else {
                    console.error(error);
                    this.statusSSE = "Error";
                }
            }
        },
        async disconnectSSE() {
            if (this.abortController) {
                await this.abortController.abort();
                this.abortController = null;
                this.statusSSE = "Desconectado";
            }
        }
    },
    watch: {
        async getSectores(newVal){
            await this.disconnectSSE();
            this.connectSSEV2(newVal);
        }
    }
};
</script>

<style>
.position_btn_notification {
    position: absolute;
    bottom: 4%;
    right: 2%;
    z-index: 9999999;
}

.position_content_notification {
    position: absolute;
    bottom: 2%;
    right: 5.5%;
    z-index: 9999999;
    width: 50vw;
    padding: 10px;
}
</style>